import React from 'react';
import { useParams } from 'react-router';
import { Result } from 'antd';
import { useQuery } from '@apollo/client';
import { PageContainer } from '@ant-design/pro-layout';
import { GET_REPORT_SUBMISSION } from 'gql/reportSubmissions';
import ReviewSection from './ReviewSection';
import ReportSubmissionDetail from './ReportSubmissionDetail';

const ResultReportSubmission = () => {
  const { id } = useParams();
  const { data, loading } = useQuery(GET_REPORT_SUBMISSION, {
    variables: {
      ids: [id],
    },
  });

  const ReportSubmission = loading ? {} : data.reportSubmissions[0];
  const getStatus = ({ status }) => {
    console.log(status);
    // if (status === 'COMPLETED') {
    //   return 'success';
    // } else {
    //   return '404';
    // }
    switch (status) {
      case 'COMPLETED':
        return 'success';
      default:
        return '404';
    }
  };
  const getTitle = ({ status }) => {
    switch (status) {
      case 'COMPLETED':
        return 'Report Submission Completed';
      default:
        return '404';
    }
  };

  return (
    <PageContainer loading={loading}>
      <Result
        status={getStatus(ReportSubmission)}
        title={getTitle(ReportSubmission)}
      >
        <ReportSubmissionDetail />
        <ReviewSection />
      </Result>
    </PageContainer>
  );
};

export default ResultReportSubmission;
